import React, { Component } from "react";
import "./CrmTourCallout.css";

const GAP = 14;
const MARGIN = 12;
const WIDTH = 280;

// Floating callout with an arrow pointing at the element matching
// `targetSelector`, plus a pulsing ring around that element. Renders nothing
// until the element is on the page.
class CrmTourCallout extends Component {
  constructor(props) {
    super(props);
    this.state = { rect: null };
  }

  componentDidMount() {
    this.measure();
    this.timer = setInterval(this.measure, 400);
    window.addEventListener("resize", this.measure);
    window.addEventListener("scroll", this.measure, true);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    window.removeEventListener("resize", this.measure);
    window.removeEventListener("scroll", this.measure, true);
  }

  measure = () => {
    const el = document.querySelector(this.props.targetSelector);
    if (!el) {
      if (this.state.rect) this.setState({ rect: null });
      return;
    }
    const r = el.getBoundingClientRect();
    const prev = this.state.rect;
    if (prev && prev.left === r.left && prev.top === r.top && prev.width === r.width && prev.height === r.height) {
      return;
    }
    this.setState({ rect: { left: r.left, top: r.top, width: r.width, height: r.height } });
  };

  render() {
    const { rect } = this.state;
    const { title, text, step, totalSteps, onSkip, onNever } = this.props;
    if (!rect) return null;

    const centerX = rect.left + rect.width / 2;
    // Stay clear of the left menu rail when it is on screen (it is off-canvas on phones)
    const rail = document.querySelector(".main-menu");
    const railWidth = rail ? Math.max(0, rail.getBoundingClientRect().right) : 0;
    const minLeft = railWidth + MARGIN;
    const width = Math.min(WIDTH, window.innerWidth - minLeft - MARGIN);
    const left = Math.max(minLeft, Math.min(centerX - width / 2, window.innerWidth - width - MARGIN));
    const arrowLeft = Math.max(18, Math.min(centerX - left, width - 18));

    return (
      <>
        <div
          className="crm-tour-ring"
          style={{ left: rect.left - 4, top: rect.top - 4, width: rect.width + 8, height: rect.height + 8 }}
        />
        <div className="crm-tour-callout" style={{ left, top: rect.top + rect.height + GAP, width }}>
          <div className="crm-tour-arrow" style={{ left: arrowLeft }} />
          <div className="crm-tour-step">Step {step} of {totalSteps}</div>
          <div className="crm-tour-title">{title}</div>
          <div className="crm-tour-text">{text}</div>
          <div className="crm-tour-actions">
            <button type="button" className="crm-tour-link" onClick={onNever}>
              Don't show again
            </button>
            <button type="button" className="crm-tour-skip" onClick={onSkip}>
              Skip
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default CrmTourCallout;
